<template lang="html">
    <transition name="popup-t">
        <div class="ds-popup" v-show="activePopup">
            <div @click="close" class="ds-popup__bg"></div>

            <div class="ds-popup__loader" v-show="loader">
                <c-loader :color="error ? 'rgba(var(--vs-danger), 1)' : 'rgba(var(--vs-primary), 1)'"></c-loader>
            </div>

            <div
                v-show="!loader"
                class="ds-popup__container"
                :class="{'full': full}"
                :style="{width, 'background-color': bgContent}"
            >
                <div class="ds-popup__container--data">
                    <div class="ds-popup__title">
                        <h3>{{ title }}</h3>
                        <vs-button
                            size="small"
                            color="primary"
                            type="filled"
                            icon-pack="feather"
                            icon="icon-x"
                            @click="close"
                        ></vs-button>
                    </div>
                    <div class="ds-popup__content"
                         ref="content"
                    >
                        <div class="ds-popup__content--data">
                            <slot></slot>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import EventBus from "@/store/eventBus";

export default {
    data() {
        return {
            timeout: null,
            settings: {
                maxScrollbarLength: 60
            }
        }
    },

    props: {
        title: {
            type: String,
            require: true
        },

        activePopup: {
            type: Boolean,
            default: false
        },

        width: {
            type: String,
            default: () => '600px'
        },

        full: {
            type: Boolean,
            default: false
        },

        bgContent: {
            type: String,
            default: () => 'white'
        }
    },

    model: {
        prop: 'activePopup',
        event: 'close'
    },

    computed: {
        loader() {
            return this.$store.getters.popupLoader
        },

        error() {
            return this.$store.getters.popupLoaderError
        },

        ajaxRequest() {
            return this.$store.getters.ajaxRequest
        }
    },

    watch: {
        activePopup(bool) {
            if (bool) {
                document.body.classList.add('ov-hidden')
            } else {
                document.body.classList.remove('ov-hidden')
            }
        },

        error(bool) {
            if (bool) {
                this.timeout = setTimeout(() => {
                    this.$store.commit('UPDATE_LOADER_STATE', false)
                    this.$store.commit('UPDATE_LOADER_STATE_SET_ERROR', false)
                    this.close()
                }, 1500)
            }
        }
    },

    methods: {
        close() {
            clearTimeout(this.timeout)
            this.$emit('close', false)

            if (this.ajaxRequest) {
                this.ajaxRequest.cancel('Cancel request')
                setTimeout(() => {
                    this.$store.commit('UPDATE_LOADER_STATE_SET_ERROR', false)
                }, 0)
            }

            EventBus.$emit('close')
            EventBus.$emit('emitPopupEvent', {type: 'close'})
        }
    },

    beforeDestroy() {
        this.$store.commit('UPDATE_LOADER_STATE', true)
        this.$store.commit('UPDATE_LOADER_STATE_SET_ERROR', false)
    }
}

</script>

<style lang="scss">
.ds-popup {
    position: fixed;
    width: 100%;
    top: 0;
    z-index: 99999;
    left: 0;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    .includeIconOnly.small {
        width: 32px !important;
        height: 32px !important;
    }

    &__bg {
        width: 100%;
        background: rgba(0, 0, 0, .4);
        position: absolute;
        top: 0;
        height: 100%;
        left: 0;
        z-index: 10;
        transition: all .25s ease;
        opacity: 1;
    }

    &__loader {
        background: white;
        z-index: 16;
        width: 200px;
        height: 200px;
        border-radius: 6px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        animation: rebound .3s;
    }

    &__container {
        max-width: calc(100% - 30px);
        max-height: calc(100% - 30px);
        z-index: 15;
        position: relative;
        border-radius: 6px;
        animation: rebound .3s;

        &--data {
            height: 100%;
        }

        &.full {
            width: 100% !important;
            height: 100vh !important;
        }
    }

    &__title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px;
        background: rgba(0, 0, 0, .05);

        h3 {
            font-size: 1.2rem;
        }

        button {
            right: -10px;
            top: -10px;
            display: block;
            position: absolute;
        }
    }

    &__content {
        overflow-y: scroll;
        overflow-x: hidden;
        max-height: calc(100vh - 72px);
        padding-left: 10px;
        padding-bottom: 10px;
        padding-top: 10px;
        height: 100%;

        &--data {
            height: 100%;
        }

        &::-webkit-scrollbar {
            width: 10px;
        }

        &::-webkit-scrollbar-track {
            background: none;
        }

        &::-webkit-scrollbar-thumb {
            background: rgba(0, 0, 0, 0.2);
            border-radius: 6px;
        }
    }
}
</style>
